import { createContext, useContext } from 'react';

export const TemporalDepthContext = createContext(0);

export const useTemporalDepth = () => useContext(TemporalDepthContext);

const ROMANS = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x'];

export function getBadgeLabel(depth: number, index: number): string {
  switch (depth) {
    case 0:
      return String(index + 1);
    case 1:
      return String.fromCharCode(65 + index);
    default:
      return ROMANS[index] ?? String(index + 1);
  }
}
